import { useSyncExternalStore } from "react";

export const isTabActive = (): boolean => document.visibilityState === "visible" && document.hasFocus();

const subscribe = (notify: () => void) => {
  document.addEventListener("visibilitychange", notify);
  window.addEventListener("focus", notify);
  window.addEventListener("blur", notify);

  return () => {
    document.removeEventListener("visibilitychange", notify);
    window.removeEventListener("focus", notify);
    window.removeEventListener("blur", notify);
  };
};

export const useActiveTab = (): boolean => useSyncExternalStore(subscribe, isTabActive, () => false);
